export class PopUpGalhed extends React.Component<{ onClose: () => void, lang: string, newDesign: boolean }, {}> {
    public render() {
        let title = "תודה שדיווחתם!";
        let text = "המידע התקבל ונשלח לבדיקה";
        let btnText = "חזרה לדף הראשי";
        if (this.props.lang === "en-GB") {
            title = "Thank you for reporting!";
            text = "The information has been received and sent for review";
            btnText = "Return to the main page";
        }

        return (
            <div className="redMailPopUp">
                <div className="popUpContent">
                       {this.props.newDesign &&
                       <button className="popUpClose" onClick={this.props.onClose}>
                        <span className="popUpCloseX"></span>
                      </button>
                      }
                      <div className="finish">
                    <p className="title">{title}</p>
                </div>
                <p className="subTitle">{text}</p>
                <button className="popUpButton">
                    <a href="/gal-hed">{btnText}</a>
                     {this.props.newDesign && <span className="stripLink_arrow"></span>}
                </button>
            </div>
              
            </div>
        )

    }

}